import React, { useState, useRef } from 'react';
import s3 from '../Clinics/wasabi';
import axios from 'axios';
import { APIURL, BUCKETNAME } from '../../../Global';
import { useTranslation } from 'react-i18next';
import './MasterBanners.css';
import { useAlert } from 'react-alert';
const AddBanner = ({ banner, token, onSuccess, onError }) => {
  const { t } = useTranslation();
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);
  const fileInputRef = useRef(null);
  const alert = useAlert();
  if (!banner) {
    return <div>{t('banners.noBannerData')}</div>;
  }

  const requiredWidth = banner.banner_space_details?.width;
  const requiredHeight = banner.banner_space_details?.height;
  const maxSizeMB = 2;

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Check file size
    // if (file.size > maxSizeMB * 1024 * 1024) {
    //   setError(`File size should be less than ${maxSizeMB}MB`);
    //   return;
    // }

    // Check image dimensions
    const reader = new FileReader();
    reader.onload = (event) => {
      const img = new window.Image();
      img.onload = () => {
        // if (img.width > requiredWidth || img.height >requiredHeight) {
        //   setError(t('banners.invalidDimensions', { width: requiredWidth, height: requiredHeight }));
        //   return;
        // }
        setSelectedFile(file);
        setError(null);
      };
      img.onerror = () => {
        setError(t('banners.invalidImageFile'));
      };
      img.src = event.target.result;
    };
    reader.readAsDataURL(file);
  };

  const handleUpdate = async () => {
    if (!selectedFile) {
      setError(t('banners.pleaseSelectImage'));
      return;
    }
    setUploading(true);
    setError(null);
    try {
      // S3 key structure: AC-Banners/{screenType}/{fileType}/{bannerSpace}/{fileName}
      const screenType = banner.banner_space_details?.screen_type || 'web';
      const fileType = banner.image_detail?.[0]?.file_type || 'Default Banner';
      const bannerID = banner.id;
      const fileName = selectedFile.name;
      const key = `AC-Banners/${screenType}/${fileType}/${bannerID}/${fileName}`;

      // 1. Upload to Wasabi
      await s3.upload({
        Bucket: BUCKETNAME,
        Key: key,
        Body: selectedFile,
        ContentType: selectedFile.type,
        ACL: 'public-read',
      }).promise();

      // 2. Update backend
      const payload = {
        image_detail: [{
          url: key,
          title: fileName,
          file_name: fileName,
          file_type: fileType
        }]
      };
      await axios.put(
        `${APIURL}/api/v1/staff/banner-detail/${banner.id}/`,
        payload,
        { headers: { Authorization: `Token ${token}` } }
      );
      setUploading(false);
      alert.success(t('banners.updatedSuccessfully'));
      if (onSuccess){
        
        onSuccess();}
    } catch (err) {
      setUploading(false);
      setError(t('banners.failedToUpdate'));
      alert.error(t('banners.failedToUpdate'));
      if (onError) onError(err);
    }
  };

  return (
    <div className="master-banner-container">
      <h2>{t('banners.updateBannerImage')}</h2>
      <div className="form-section">
        <label>
          {t('banners.chooseNewImage')}
          <span style={{ color: '#888', fontSize: '0.95em', marginLeft: 8 }}>
            ({t('banners.requiredSize', { width: requiredWidth, height: requiredHeight, maxSize: maxSizeMB })})
          </span>
        </label>
        <div className="custom-file-input-wrapper">
          <input
            type="file"
            accept="image/*"
            onChange={handleFileChange}
            ref={fileInputRef}
            style={{ display: 'none' }}
            id="file-input"
          />
          <button
            type="button"
            className="custom-file-button"
            onClick={() => fileInputRef.current?.click()}
          >
            {t('banners.chooseFile')}
          </button>
          <span className="file-name-display">
            {selectedFile ? selectedFile.name : t('banners.noFileChosen')}
          </span>
        </div>
      </div>
      {error && <div style={{ color: 'red' }}>{error}</div>}
      <div className="form-actions">
        <button className="create-btn" onClick={handleUpdate} disabled={uploading}>
          {uploading ? t('banners.uploading') : t('banners.updateImage')}
        </button>
      </div>
    </div>
  );
};

export default AddBanner;
